import { combineReducers } from 'redux';

import byCategory from './byCategory';
import structuredSpecs from './structuredSpecs';

export default combineReducers({
    byCategory,
    structuredSpecs,
});
